function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 4.25L14 2.25L11 0.25V1.75H4.57143C2.32281 1.75 0.5 3.57299 0.5 5.82169C0.5 6.89042 0.912382 7.86395 1.58578 8.59001L2.31898 7.90999C1.81031 7.36154 1.5 6.62842 1.5 5.82169C1.5 4.12521 2.87516 2.75 4.57143 2.75H11V4.25Z",
  fill: "#BABABA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 10.25L6 8.25L6 9.75L12.4286 9.75C14.1248 9.75 15.5 8.37479 15.5 6.67831C15.5 5.87158 15.1897 5.13846 14.681 4.59001L15.4142 3.90999C16.0876 4.63605 16.5 5.60958 16.5 6.67831C16.5 8.92701 14.6772 10.75 12.4286 10.75L6 10.75V12.25L3 10.25Z",
  fill: "#BABABA"
});

var SvgIconRepeat = function SvgIconRepeat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRepeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_repeat.002a44b7.svg";
export { ForwardRef as ReactComponent };